import React, { useEffect, useRef, useState } from 'react';
import { useRouteMatch } from "react-router-dom";
import { motion } from "framer-motion"
import './App.css';
import { ComboBox, createTheme, DefaultEffects, Dropdown, IButtonStyles, IComboBoxOption, IDropdownOption, initializeIcons, loadTheme, MotionAnimations, MotionDurations, PrimaryButton } from '@fluentui/react';
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import Cards from './Cards/Cards';
import Results from './Results/Results';
import Form from './Form/Form';


function App() {

  // let matchHome = useRouteMatch({
  //   path: "/",
  //   exact: true
  // });
  // let matchKlanten = useRouteMatch({
  //   path: "/klanten",
  //   exact: true
  // });

  initializeIcons();

  loadTheme(createTheme({
    // defaultFontStyle: { fontFamily: 'GT-Walsheim-Regular', fontWeight: 'regular' },
    defaultFontStyle: { fontFamily: 'Verdana', fontWeight: 'regular', color: 'rgb(7, 18, 81)' },
    palette: {
      themePrimary: 'rgb(255,95,80)',//'#11b3c0',
      neutralPrimary: 'rgb(7, 18, 81)',
      neutralSecondary: 'rgb(7, 18, 81)'
    }
  }));

  const btnStyles: IButtonStyles = {
    rootHovered: {
      backgroundColor: "rgb(255,95,80)",
      border: 0
    },
    flexContainer: {
      flexDirection: 'row-reverse'
    },
    rootPressed: {
      backgroundColor: "#1a1b4a",
      border: 0
    },
    root: {
      fontSize: '18px',
      padding: '20px',
      width: '220px',
      border: 0,
      borderRadius: '10px'
    }
  };

  const CardsToDisplay: card[] = [
    {
      id: 0,
      name: 'Mee naar de huisarts/ziekenhuis',
      imageurl: '/img/cards/1.png'
    },
    {
      id: 1,
      name: 'Boodschappen',
      imageurl: '/img/cards/2.png'
    },
    {
      id: 2,
      name: 'Meerdere keren in de week koken',
      imageurl: '/img/cards/3.png'
    },
    {
      id: 3,
      name: 'Administratie',
      imageurl: '/img/cards/4.png'
    },
    {
      id: 4,
      name: 'Langs voor gezelschap',
      imageurl: '/img/cards/5.png'
    },
    {
      id: 5,
      name: 'Pgb/Wmo etc. aanvragen',
      imageurl: '/img/cards/6.png'
    },
    {
      id: 6,
      name: 'Verpleging/verzorging aanvragen',
      imageurl: '/img/cards/7.png'
    },
    {
      id: 7,
      name: 'Contact met thuiszorg',
      imageurl: '/img/cards/8.png'
    },
    {
      id: 8,
      name: 'Iedereen op de hoogte houden',
      imageurl: '/img/cards/9.png'
    },
    {
      id: 9,
      name: 'Tuin onderhouden',
      imageurl: '/img/cards/10.png'
    },
    {
      id: 10,
      name: 'Begeleiden in huis',
      imageurl: '/img/cards/11.png'
    },
    {
      id: 11,
      name: 'Vervoer en begeleiding buitenshuis',
      imageurl: '/img/cards/12.png'
    },
    {
      id: 12,
      name: 'Regelzaken i.v.m. zorgsituatie',
      imageurl: '/img/cards/13.png'
    },
    {
      id: 13,
      name: 'Nachtzorg',
      imageurl: '/img/cards/14.png'
    },
    {
      id: 14,
      name: 'Huishoudelijke taken/klusjes in huis',
      imageurl: '/img/cards/15.png'
    },
    {
      id: 15,
      name: 'Maaltijden verzorgen',
      imageurl: '/img/cards/16.png'
    },
    {
      id: 16,
      name: 'Medicijnen klaarleggen/toedienen',
      imageurl: '/img/cards/17.png'
    },
    {
      id: 17,
      name: 'Persoonlijke verzorging',
      imageurl: '/img/cards/18.png'
    },
    {
      id: 18,
      name: 'Luisterend oor bieden',
      imageurl: '/img/cards/19.png'
    }
  ]

  const [step, setStep] = useState<number>(0)
  const results = useRef<card[]>([]);

  const [accounts, setAccounts] = useState<IComboBoxOption[]>([]);
  const [selectedAccount, setSelectedAccount] = useState<IComboBoxOption>();

  // mode 0: https://mantelzorgtest.fello.nl
  // mode 1: https://mantelzorgtest-pr.fello.nl
  const applicationMode = (window.location.origin === 'http://localhost:3000' || window.location.hostname.toLowerCase() === 'mantelzorgtest-pr.fello.nl') ? 1 : 0;

  console.log('v1', applicationMode); // 1 for pr and dev scenario

  useEffect(() => {
    // if (matchKlanten) {
    fetch('../accounts.json')
      .then(res => res.json())
      .then(res => {

        setAccounts([...res.map((r: any) => {
          return {
            key: r.name,
            text: r.name
          }
        }), { key: 'none', text: 'Mijn organisatie/werkgever staat er niet tussen' }]);
      })
    // }
  }, []);


  return (
    <div>
      {/* <div>
        <div style={{ boxShadow: DefaultEffects.elevation8, padding: '15px 0 15px 25px', backgroundColor: 'white' }}>
          <img src='img/logo.png' alt='Fello' style={{ width: '120px' }} />
        </div>
      </div> */}


      <div className='main'>
        <div className='main-inner'>
          {step === 0 &&
            <div className='cardsection' style={{ textAlign: 'center' }}>
              <img src='/img/logo.svg' alt='Fello' style={{ width: '150px', padding: '20px' }} />
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0 }}
              // style={{ fontWeight: 600 }}
              >
                <Text>
                  De meeste mensen hebben niet in de gaten dat ze mantelzorger zijn. Dat klinkt als groots en meeslepend. En die paar keer boodschappen doen voor je moeder, dat doe je toch gewoon?
                </Text>
              </motion.div>
              <br />
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1 }}
              >
                <Text>
                  Toch ben je dan eigenlijk al mantelzorger. En vaak begint het met een paar kleine taken, maar na een tijd merk je toch dat je er steeds meer tijd en energie mee kwijt bent.
                </Text>
              </motion.div>
              <br />
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2 }}
              >
                <Text>
                  Deze mantelzorgtest geeft inzicht in welke ballen jij allemaal omhoog houdt en wat de impact van het mantelzorgen is op jouw dagelijkse leven.
                </Text>
              </motion.div>
              <br /><br />
              {/* {matchKlanten || matchHome && */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.5 }}
              >
                <Text>
                  Om door te gaan, selecteer je werkgever:
                </Text>
                <br /><br />
                <div style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'left' }} >
                  <Dropdown options={accounts} onChanged={(option: IDropdownOption, index?: number) => {
                    setSelectedAccount(option);
                  }} />
                </div>
                <br /><br />
              </motion.div>
              {/* } */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 3 }}
              >
                <PrimaryButton iconProps={{ iconName: 'Forward' }} disabled={!selectedAccount} styles={btnStyles} text="Start de test" onClick={() => { setStep(1) }} />
              </motion.div>
            </div>
          }
          {step === 1 &&
            <div className='fadein'>
              <Cards
                cards={CardsToDisplay}
                finished={(res: card[]) => {
                  results.current = res;
                  setStep(2);
                }}
              />
            </div>
          }
          {step === 2 && results.current.filter(r => r.result === true).length === 0 &&
            <div>
              <Results results={results.current} next={() => setStep(3)} />
            </div>
          }
          {step === 2 && results.current.filter(r => r.result === true).length > 0 &&
            <div>
              <Form applicationMode={applicationMode} results={results.current} account={selectedAccount} saved={() => setStep(4)} />
            </div>
          }
          {step === 4 &&
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0 }}
              className='cardsection' style={{ textAlign: 'center' }}>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <Text>
                  Bedankt
                </Text>
              </motion.div>
              <br />
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
              >
                <Text>
                  We hebben je een email gestuurd met het resultaat. Houd ook je ongewenste email in de gaten, mogelijk komt het bericht daar binnen.
                  <br />
                </Text>
              </motion.div>
            </motion.div>
          }
        </div>
      </div>
    </div>
    // <div className="ms-Grid" dir="ltr">
    //   <div className="ms-Grid-row">
    //     <div className="ms-Grid-col ms-sm6 ms-md8 ms-lg10">B</div>
    //   </div>
    // </div>
  );
}

export interface card {
  id: number;
  name: string;
  imageurl: string;
  result?: boolean;
}

export default App;
